import { TicketStatus } from "@jugl-web/rest-api";
import isAfter from "date-fns/isAfter";

interface TicketLike {
  dueDate: Date | null;
  status: TicketStatus;
}

export const isTicketOverdue = (ticket: TicketLike) => {
  if (!ticket.dueDate) {
    return false;
  }

  if (ticket.status === "resolved") {
    return false;
  }

  return isAfter(new Date(), ticket.dueDate);
};
